module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.analise) ? _c('div', {
    staticClass: "analiseCadastral"
  }, [_c('a', {
    staticClass: "fechar",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Fechar janela")]), _vm._v(" "), _c('div', {
    staticClass: "titulo"
  }, [_vm._v("Análise Cadastral")]), _vm._v(" "), _c('div', {
    staticClass: "bloqueioSugerido"
  }, [_vm._v("\n    Bloqueio sugerido: "), (_vm.analise.bloqueioSugerido) ? _c('a', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Sim")]) : _c('a', {
    staticClass: "btn btn-success"
  }, [_vm._v("Não existe sugestão de bloqueio")])]), _vm._v(" "), _c('div', {
    staticClass: "cadastrosRelacionados"
  }, [_c('div', {
    staticClass: "telefones m-t"
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Telefones iguais")]), _vm._v(" "), _vm._l((_vm.analise.telefonesIguais), function(telefone, i) {
    return _c('div', {
      key: i,
      staticClass: "lista"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v("\n          Arrematante "), _c('a', {
      staticClass: "text-info font-bold",
      attrs: {
        "href": '/#/website/arrematantes/' + telefone.arrematante.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(telefone.arrematante.apelido))]), _vm._v(" com status\n          "), _c('analise-a-status', {
      attrs: {
        "arrematante": telefone.arrematante
      }
    }), _vm._v("\n          tem o mesmo telefone: " + _vm._s(telefone.telefone) + "\n        ")], 1)])
  }), _vm._v(" "), (!_vm.analise.telefonesIguais || !_vm.analise.telefonesIguais.length) ? _c('div', [_vm._v("Nenhum registro encontrado")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "enderecos m-t"
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Endereços iguais")]), _vm._v(" "), _vm._l((_vm.analise.enderecosIguais), function(endereco, i) {
    return _c('div', {
      key: i,
      staticClass: "lista"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v("\n          Arrematante "), _c('a', {
      staticClass: "text-info font-bold",
      attrs: {
        "href": '/#/website/arrematantes/' + endereco.arrematante.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(endereco.arrematante.apelido))]), _vm._v(" com status\n          "), _c('analise-a-status', {
      attrs: {
        "arrematante": endereco.arrematante
      }
    }), _vm._v("\n          tem o mesmo endereço: " + _vm._s(endereco.endereco) + "\n        ")], 1)])
  }), _vm._v(" "), (!_vm.analise.enderecosIguais || !_vm.analise.enderecosIguais.length) ? _c('div', [_vm._v("Nenhum registro encontrado")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dadosParecidos m-t"
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Outros arrematantes com dados parecidos")]), _vm._v(" "), _vm._l((_vm.analise.dadosParecidos), function(dado, i) {
    return _c('div', {
      key: i,
      staticClass: "lista"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v("Arrematante "), _c('a', {
      staticClass: "text-info font-bold",
      attrs: {
        "href": '/#/website/arrematantes/' + dado.arrematante.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(dado.arrematante.apelido))]), _vm._v(" com status\n          "), _c('analise-a-status', {
      attrs: {
        "arrematante": dado.arrematante
      }
    }), _vm._v(" tem dados parecidos.\n        ")], 1)])
  }), _vm._v(" "), (!_vm.analise.dadosParecidos || !_vm.analise.dadosParecidos.length) ? _c('div', [_vm._v("Nenhum registro encontrado")]) : _vm._e()], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcfa495","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/AnaliseCadastral.vue
// module id = 783
// module chunks = 2